var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerified(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2576",
    "data-name": "Group 2576",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 59.877,
    viewBox: "0 0 60 59.877",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9916",
    "data-name": "Path 9916",
    d: "M994.3,188.455a11.534,11.534,0,0,0-6.16-10.287,12.136,12.136,0,0,0,.678-4,11.155,11.155,0,0,0-10.9-11.4,9.815,9.815,0,0,0-3.819.739,10.691,10.691,0,0,0-19.589,0,9.814,9.814,0,0,0-3.819-.739,11.155,11.155,0,0,0-10.9,11.4,12.136,12.136,0,0,0,.678,4,11.71,11.71,0,0,0-.616,20.267,11.885,11.885,0,0,0-.062,1.478,11.155,11.155,0,0,0,10.9,11.4,9.815,9.815,0,0,0,3.819-.739,10.691,10.691,0,0,0,19.589,0,9.785,9.785,0,0,0,3.819.678,11.155,11.155,0,0,0,10.9-11.4,11.965,11.965,0,0,0-.123-1.478,11.312,11.312,0,0,0,5.606-9.918Zm-18.912-9.548-12.382,18.542a2.165,2.165,0,0,1-1.786.924,2.028,2.028,0,0,1-1.17-.37l-.308-.246-6.9-6.838a2.134,2.134,0,0,1,3.018-3.018l5.051,5.051,10.9-16.386a2.17,2.17,0,0,1,2.957-.616,2.064,2.064,0,0,1,.616,2.957Z",
    transform: "translate(-934.3 -157.1)",
    fill: "#439cd6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.4ec1811c99ea76f89b1765610cfc152c.svg";
export { ForwardRef as ReactComponent };